import { createContext, useContext, useEffect, useState } from 'react';
import { translations } from './translations';

const LangContext = createContext({ lang: 'bs', setLang: () => {}, t: translations.bs });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('krug-lang') || 'bs');

  useEffect(() => {
    localStorage.setItem('krug-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] || translations.bs }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
